//AES 解密 加密
function encryptByAES(message, key) {
  var keyHex = window.CryptoJS.enc.Utf8.parse(key);
  var encrypted = window.CryptoJS.AES.encrypt(message, keyHex, {
    mode: window.CryptoJS.mode.ECB,
    padding: window.CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
//AES 解密
function decryptByAES(ciphertext, key) {
  var keyHex = window.CryptoJS.enc.Utf8.parse(key);
  // direct decrypt ciphertext
  var decrypted = window.CryptoJS.AES.decrypt(
    {
      ciphertext: window.CryptoJS.enc.Base64.parse(ciphertext)
    },
    keyHex,
    {
      mode: window.CryptoJS.mode.ECB,
      padding: window.CryptoJS.pad.Pkcs7
    }
  );
  return decrypted.toString(window.CryptoJS.enc.Utf8);
}

export default {
  decryptByAES,
  encryptByAES
};
